// Utils
import Cookies from 'js-cookie';

import { dispatch } from 'utils/theme';

class Wishlist {
  constructor() {
    this.cookieName = 'wishlist';
    this.cookieSettings = {
      expires: 365,
    };

    this.items = this.getItems();
  }

  /**
   * Add an item.
   *
   * @param handle
   * @param id
   */
  add(handle, id) {
    console.log(`add: ${handle} - ${id}`);
    const item = { handle, id };
    const index = this.getItemIndex(handle);

    if (index === -1) {
      this.items.push(item);
    } else {
      this.items.splice(index, 1, item);
    }

    this.save();

    dispatch('add-to-wishlist', {
      handle,
      id,
    });
  }

  /**
   * Remove an item.
   *
   * @param handle
   */
  remove(handle) {
    console.log(`remove: ${handle}`);
    const index = this.getItemIndex(handle);

    if (index > -1) {
      this.items.splice(index, 1);
      this.save();
    }

    dispatch('remove-from-wishlist', {
      handle,
    });
  }

  /**
   * Replace an item.
   *
   * @param handle
   * @param replacement
   */
  replace(handle, replacement) {
    const index = this.getItemIndex(handle);

    if (index > -1) {
      this.items.splice(index, 1, {
        handle: replacement,
        id: null,
      });
      this.save();
    } else {
      this.add(replacement);
    }
  }

  /**
   * Toggle an item.
   *
   * @param handle
   * @param id
   */
  toggle(handle, id = null) {
    if (this.getItemIndex(handle) > -1) {
      this.remove(handle);
    } else {
      this.add(handle, id);
    }
  }

  /**
   * Save current items to cookie.
   */
  save() {
    Cookies.set(this.cookieName, JSON.stringify(this.items), this.cookieSettings);
  }

  /**
   * Get list of items.
   *
   * @returns {*[]}
   */
  getItems() {
    if (Wishlist.shouldUseCookies()) {
      const content = Cookies.get(this.cookieName);

      if (content) {
        return JSON.parse(content);
      }
    } else {
      const params = new URLSearchParams(window.location.search.slice(1));
      const handles = params.getAll('handle');
      const ids = params.getAll('id');

      return handles.map((handle, index) => {
        let id = ids[index];

        if (id === 'null') {
          id = null;
        } else {
          id = parseInt(id, 10);
        }

        return {
          handle,
          id,
        };
      });
    }

    return [];
  }

  /**
   * Get index of item.
   *
   * @param handle
   * @returns {number}
   */
  getItemIndex(handle) {
    return this.items.findIndex((item) => item.handle === handle);
  }

  /**
   * Remove all items.
   */
  empty() {
    this.items = [];
    this.save();
  }

  /**
   * Determinate if should get items from URL.
   *
   * @returns {boolean}
   */
  static shouldUseURL() {
    const { href } = window.location;

    return href.indexOf('handle=') !== -1 && href.indexOf('id=') !== -1;
  }

  /**
   * Determinate if should get items from Cookies.
   *
   * @returns {boolean}
   */
  static shouldUseCookies() {
    return Wishlist.shouldUseURL() === false;
  }

  /**
   * Get shareable URL query params.
   *
   * @returns {string}
   */
  getShareableURL() {
    const url = new URLSearchParams();

    this.items.forEach((item) => {
      url.append('handle', item.handle);
      url.append('id', item.id);
    });

    return `${window.location.origin}${window.location.pathname}?${url.toString()}`;
  }
}

export default new Wishlist();
